import React from 'react'
import '../../Fonts/Foco-Bold.ttf'
import styles from './Error.module.css'
import icon from '../Assets/icon-ops.svg'

const Error = ({ ...props }) => {
  return (

        <article className={styles.boxMessage}>
            <div className={styles.imgTop}>
                <img src={icon} alt="icon" />
            </div>
            <p className={styles.message}> Ops!</p>
            <p className={styles.message}>
                {props.message || 'Infelizmente não conseguimos encontrar cupons disponíveis para você agora :( Tente novamente mais tarde.'}
            </p>
        </article>
  )
}

export default Error
